import { useContext, useState } from 'react';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import { ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
import { UserContext } from '../context/UserContext';
import {useCart} from '../hooks/add_to_cart';

export function CompleteSale({ setShowCompleteSale, showCompleteSale }) {
  const {logOutFunction} = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const {setTostMessage} = useContext(TostMessageContext);
  const [cookies, removeCookie, setCookie] = useCookies();
  const [formFields, setFormFields] = useState({});
  const {parse, formatAmount} = useCart();


    async function pay_ngn () {
        const formData = new FormData();
        formData.append('selections', JSON.stringify(cookies?.myCart));
        Object.entries(formFields).forEach(([key, value]) => {
            formData.append(key, value);
        });

        setLoading(true)
        try {
            const response = await axios.post(base_url + '/pay_ngn.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.status) {
                setTostMessage({
                    messageType: 'success',
                    message: response.data.message
                })
                // removeCookie("myCart", { path: "/" });
                setCookie("myCart", [], {
                    path: "/",
                    maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
                    secure: true,
                    sameSite: "strict"
                });
                setShowCompleteSale(false);
                setFormFields({});
            } else {
                setTostMessage({
                    messageType: 'error',
                    message: response.data.message
                })
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            setTostMessage({
                messageType: 'error',
                message: 'Network error'
            })
        }
    }
    
  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 min-h-[100px] w-[85%] lg:w-[35%] mx-auto my-auto bg-white rounded-[15px] animate-scaleIn'>
                <div className='w-[80%] flex justify-end text-underline text-[#ff0000]'>
                    <p className='cursor-pointer' onClick={() => setShowCompleteSale(false)}>Cancel</p>
                </div>
                <a className='text-dark text-[17px] font-bold'>Complete Sale</a>
                <a className='text-dark text-[15px] font-semibold'>{'Please fill the form appropriately'}</a>
                    <div className="w-[80%] mx-auto flex flex-col mt-2">
                        <label>Outlets</label>
                        <select
                            className="w-full mx-auto border p-2 rounded my-2"
                            onChange={(e) => setFormFields({...formFields, location_id: e.target.value})}
                        >
                            <option value="">All Outlets</option>
                            {cookies?.userProfile?.locations?.map((item, index) => 
                                <option key={index} value={item.location_id}>{item.name}</option>
                            )}
                        </select>
                    </div>
                    <div className="w-[80%] mx-auto flex flex-col mt-2">
                        <label>Channel</label>
                        <select
                            className="w-full mx-auto border p-2 rounded my-2"
                            onChange={(e) => setFormFields({...formFields, channel: e.target.value})}
                        >
                            <option value="">Choose a Channel</option>
                            <option value="WALK-IN">Walk-in</option>
                            <option value="INSTAGRAM">Instagram</option>
                            <option value="FACEBOOK">Facebook</option>
                            <option value="WHATSAPP">WhatsApp</option>
                        </select>
                    </div>
                    <div className='w-[80%] mx-auto flex flex-col mt-2'>
                        <label>Discount Applied in NGN (Optional)</label>
                        <input type='default' 
                        value={formatAmount(formFields?.discount_applied)}
                        onChange={(e) => {
                            const raw = parse(e.target.value);
                            // allow only numbers
                            raw.replace(/,/g, '');
                            if (!/^\d*$/.test(raw)) return;
                            setFormFields({...formFields, discount_applied: raw})
                        }} className="w-full mx-auto border-primary border p-2 rounded my-2" placeholder="Enter Discount Amount" />
                    </div>
                  <div className='w-[80%] mx-auto flex flex-col mt-2'>
                    <label>Full Name (Optional)</label>
                    <input type='default' onChange={(e) => setFormFields({...formFields, full_name: e.target.value})} className="w-full mx-auto border p-2 rounded my-2" placeholder="Full Name" />
                  </div>
                  <div className='w-[80%] mx-auto flex flex-col mt-2'>
                    <label>Email (Optional)</label>
                    <input type='default' onChange={(e) => setFormFields({...formFields, email: e.target.value})} className="w-full mx-auto border p-2 rounded my-2" placeholder="Email (Login ID)" />
                  </div>
                  <div className='w-[80%] mx-auto flex flex-col mt-2'>
                    <label>Phone Number (Optional)</label>
                    <input type='default' onChange={(e) => setFormFields({...formFields, phone: e.target.value})} className="w-full mx-auto border p-2 rounded my-2" placeholder="Login Password" />
                  </div>
                  <div className='w-[80%] mx-auto flex flex-col mt-2'>
                    <label className="flex items-center gap-2 text-sm">
                    <input
                        type="checkbox"
                        checked={formFields?.create_account}
                        onChange={(e) =>
                        setFormFields({
                            ...formFields,
                            create_account: e.target.checked
                        })
                        }
                        className="accent-red-500"
                    />
                    Use or Create customer accunt
                    </label>
                  </div>
                    <div className="flex justify-between mt-5">
                        <button
                            onClick={() => pay_ngn()}
                            className="
                            bg-[#037684] text-white rounded-full font-semibold
                            px-8 py-3 transition hover:bg-primary
                            w-full md:w-auto md:self-center
                            "
                        >
                            Check-out
                        </button>
                    </div>
                    {loading ? (
                        <ClockLoader
                            color={'#212121'}
                            loading={loading}
                            size={25}
                            className='mt-3'
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                        ) : null
                    }
            </div>  
        </div>
    )
}

